import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { BodyCell } from '../BodyCell'

export const Duo = ({
  children,
  spacing,
}: {
  children?: React.ReactNode
  spacing?: number
}) => {
  const { isDuoSelected } = usePlansContext()

  return (
    <BodyCell isSelected={isDuoSelected} spacing={spacing}>
      {children}
    </BodyCell>
  )
}
